import React, { useEffect, useState } from 'react';

import { Button, CloseButton, Dialog, DialogActions } from '../base';
import { DialogTitle, EmployeeName } from '../EditTimeclockModal/styled';
import useStyles from '../EditTimeclockModal/useStyles';
import DurationInput from 'components/DurationInput';
import { useTimeStates } from 'hooks/useTimeStates';

const EditLunchTimeModal = ({ onChange, onReset, onSubmit, data, onClose, open }) => {
  const classes = useStyles();
  const { hours } = useTimeStates({
    hourMaxValue: 13,
    hourStart: 0,
    takeSettingsHours: true,
    overlapsHourMaxValue: true,
  });
  const [lunchTime, setLunchTime] = useState({ hour: undefined, minute: undefined });

  useEffect(() => {
    if (!data) return;
    let dataLunchTime = data.lunchTime;
    if (typeof lunchTime.hour === 'undefined' && typeof lunchTime.minute === 'undefined') {
      dataLunchTime = data.modified?.lunchTime || data.lunchTime;
    }
    const hour = Math.trunc(dataLunchTime) || 0;
    const minute = Math.round((dataLunchTime - hour) * 60) || 0;
    setLunchTime({ hour, minute });
  }, [data]);

  const handleChange = (next) => {
    setLunchTime({ hour: next.hours, minute: next.minutes });
    onChange({ ...data, lunchTime: next.hours + next.minutes / 60 });
  };

  return (
    <Dialog open={open}>
      <CloseButton onClick={onClose} />
      <DialogTitle className={classes.title} disableTypography={true}>
        Timeclock edit mode
      </DialogTitle>
      {data ? (
        <>
          <EmployeeName>{data.user.profile.fullName}</EmployeeName>
          <form className={classes.root}>
            <div className={classes.form}>
              <label className={classes.field}>
                Lunch Time:
                <div style={{ margin: '8px 0', paddingRight: '39px' }}>
                  <DurationInput
                    title="Lunch time"
                    value={{ hours: lunchTime.hour, minutes: lunchTime.minute }}
                    onChange={handleChange}
                    maxHours={hours.length - 1}
                    minuteStep={15}
                  />
                </div>
              </label>
            </div>
          </form>
        </>
      ) : null}
      <DialogActions disableSpacing={false}>
        <Button variant={'outlined'} color={'secondary'} fullWidth={true} onClick={onReset}>
          Cancel
        </Button>
        <Button variant={'outlined'} fullWidth={true} onClick={onSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditLunchTimeModal;
